var $85a5f86b715fe7db$exports = {};
//All animations on elements whitch should visible during scroll
const $85a5f86b715fe7db$var$buttons = document.querySelectorAll(".c-btn");
$85a5f86b715fe7db$var$buttons.forEach((btn)=>{
    btn.addEventListener("mouseover", ()=>{
        if (btn.firstElementChild) btn.firstElementChild.classList.contains("arrowDark") === true ? btn.firstElementChild.classList.add("longDark") : btn.firstElementChild.classList.add("long");
    });
    btn.addEventListener("mouseout", ()=>{
        if (btn.firstElementChild) {
            btn.firstElementChild.classList.contains("arrowDark") === true ? btn.firstElementChild.classList.remove("longDark") : btn.firstElementChild.classList.remove("long");
            btn.firstElementChild.classList.remove("long");
        }
    });
});
const $85a5f86b715fe7db$var$audioToggleButton = document?.querySelectorAll('.audio-toggle');
$85a5f86b715fe7db$var$audioToggleButton?.forEach((btn)=>{
    btn.addEventListener("click", ()=>{
        const video = btn?.parentElement?.querySelector('video');
        video.muted = !video.muted;
        btn?.classList?.toggle('not-muted');
    });
});
// //fadeup
function $85a5f86b715fe7db$var$fadeUp() {
    const items = document.querySelectorAll(".js-fade-up");
    const options = {
        rootMargin: "0px 0px -25px 0px"
    };
    const observer = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                observer.unobserve(entry.target);
            }
        });
    }, options);
    items.forEach((item)=>{
        observer.observe(item);
    });
}
$85a5f86b715fe7db$var$fadeUp();
function $85a5f86b715fe7db$var$fadeUp2() {
    const items = document.querySelectorAll(".js-fade-up2");
    const options = {
        rootMargin: "0px 0px -25px 0px"
    };
    const observer = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                observer.unobserve(entry.target);
            }
        });
    }, options);
    items.forEach((item)=>{
        observer.observe(item);
    });
}
$85a5f86b715fe7db$var$fadeUp2();
//fadeDown
function $85a5f86b715fe7db$var$fadeDown() {
    const items = document.querySelectorAll(".js-fade-down");
    const options = {
        rootMargin: "0px 0px -25px 0px"
    };
    const observer = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                observer.unobserve(entry.target);
            }
        });
    }, options);
    items.forEach((item)=>{
        observer.observe(item);
    });
}
$85a5f86b715fe7db$var$fadeDown();
//fade Up Right
function $85a5f86b715fe7db$var$fadeUpRight() {
    const items = document.querySelectorAll(".js-fadeUp-right");
    const options = {
        rootMargin: "0px 0px -25px 0px"
    };
    const observer = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                observer.unobserve(entry.target);
            }
        });
    }, options);
    items.forEach((item)=>{
        observer.observe(item);
    });
}
$85a5f86b715fe7db$var$fadeUpRight();
//fade Up Left
function $85a5f86b715fe7db$var$fadeUpLeft() {
    const items = document.querySelectorAll(".js-fadeUp-left");
    const options = {
        rootMargin: "0px 0px -25px 0px"
    };
    const observer = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    entry.target.classList.add("is-visible");
                    observer.unobserve(entry.target);
                }
            });
        });
    }, options);
    items.forEach((item)=>{
        observer.observe(item);
    });
}
$85a5f86b715fe7db$var$fadeUpLeft();
//fade left
function $85a5f86b715fe7db$var$fadeLeft() {
    const items = document.querySelectorAll(".js-fade-left");
    const options = {
        rootMargin: "0px 0px -25px 0px"
    };
    const observer = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                observer.unobserve(entry.target);
            }
        });
    }, options);
    items.forEach((item)=>{
        observer.observe(item);
    });
}
$85a5f86b715fe7db$var$fadeLeft();
function $85a5f86b715fe7db$var$fadeLeft2() {
    const items = document.querySelectorAll(".js-fade-left2");
    const options = {
        rootMargin: "0px 0px -25px 0px"
    };
    const observer = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                observer.unobserve(entry.target);
            }
        });
    }, options);
    items.forEach((item)=>{
        observer.observe(item);
    });
}
$85a5f86b715fe7db$var$fadeLeft2();
//fade right
function $85a5f86b715fe7db$var$fadeRight() {
    const items = document.querySelectorAll(".js-fade-right");
    const options = {
        rootMargin: "0px 0px -25px 0px"
    };
    const observer = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                observer.unobserve(entry.target);
            }
        });
    }, options);
    items.forEach((item)=>{
        observer.observe(item);
    });
}
$85a5f86b715fe7db$var$fadeRight();
//fade right
function $85a5f86b715fe7db$var$step() {
    const items = document.querySelectorAll(".js-step");
    const options = {
        rootMargin: "0px 0px -25px 0px"
    };
    let number = 1;
    const observer = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add(`js-step--${number}`);
                number++;
                observer.unobserve(entry.target);
            }
        });
    }, options);
    items.forEach((item)=>{
        observer.observe(item);
    });
}
$85a5f86b715fe7db$var$step();
//fade right
function $85a5f86b715fe7db$var$underlineAnimation() {
    const items = document.querySelectorAll(".js-underlineAnimation");
    const options = {
        rootMargin: "0px 0px -25px 0px"
    };
    let number = 1;
    const observer = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add("st-boldUnderline__changeColor");
                number++;
                observer.unobserve(entry.target);
            }
        });
    }, options);
    items.forEach((item)=>{
        observer.observe(item);
    });
}
$85a5f86b715fe7db$var$underlineAnimation();
function $85a5f86b715fe7db$var$underlineAnimation2() {
    const items = document.querySelectorAll(".js-underlineAnimation2");
    const options = {
        rootMargin: "0px 0px -25px 0px"
    };
    let number = 1;
    const observer = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add("st-boldUnderline__changeColor2");
                number++;
                observer.unobserve(entry.target);
            }
        });
    }, options);
    items.forEach((item)=>{
        observer.observe(item);
    });
}
$85a5f86b715fe7db$var$underlineAnimation2();
//Big heading animation
function $85a5f86b715fe7db$var$heading() {
    const items = document.querySelectorAll(".js-heading");
    const options = {
        rootMargin: "0px 0px -300px 0px"
    };
    const observer = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add("entry");
                observer.unobserve(entry.target);
            }
        });
    }, options);
    items.forEach((item)=>{
        observer.observe(item);
    });
}
$85a5f86b715fe7db$var$heading();
// Cookies
function $85a5f86b715fe7db$var$setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 86400000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function $85a5f86b715fe7db$var$getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) == ' ')c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}
const $85a5f86b715fe7db$var$video_anim = document.body.querySelector('video.video__anim');
$85a5f86b715fe7db$var$video_anim && setTimeout(()=>{
    $85a5f86b715fe7db$var$video_anim.play();
}, 1000);
const $85a5f86b715fe7db$var$aiTitle = document.querySelector('.hero-ai__title');
if ($85a5f86b715fe7db$var$aiTitle) setTimeout(()=>{
    $85a5f86b715fe7db$var$aiTitle.classList.add('show-element');
    setTimeout(()=>{
        $85a5f86b715fe7db$var$aiTitle.querySelector('.hero-ai__title-end').classList.add('show-element');
    }, 100);
}, 200);


//# sourceMappingURL=flipside-www-2022.9e04b72a.js.map
